import store from '@/store'
import { lazyLoad } from '../../index'

export default {
  path: 'users',
  component: lazyLoad('Admin/Data/Users'),
}
